import { Spacer } from "components/views/atoms/Atoms"
import { BodyLarge, BodySmall } from "components/views/atoms/Bodies"
import { RoundedRectangle } from "components/views/atoms/roundedrectangle/RoundedRectangle"
import { RRButtonFooter } from "components/views/atoms/roundedrectangle/RRButtonFooter"
import L10n from "lib/carrot-l10n"
import React from "react"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

type BenefitsEnrollmentExpiredProps = {
  onClickEnroll: () => void
}

const BenefitsEnrollmentExpired = ({ onClickEnroll }: BenefitsEnrollmentExpiredProps): JSX.Element => {
  return (
    <RoundedRectangle backgroundColor="mint-alternate">
      <BodyLarge color="black-80">{l`To access your funds, update your insurance info`}</BodyLarge>
      <Spacer height={1} />
      <BodySmall color="black-80">{l`Your insurance plan information has expired. Update now to get access to your Carrot funds`}</BodySmall>
      <RRButtonFooter onClick={onClickEnroll} outline>
        {l`Update plan info`}
      </RRButtonFooter>
    </RoundedRectangle>
  )
}

export default BenefitsEnrollmentExpired
